import React from 'react'

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import {ColorPalette} from "../../../fields3/color-coding/color-coding"
import {isBulkSelection} from "../../../gd/right-click-menu"

type Props = {
    className?              : string

    taskId?                 : ID
    tag                     : any
    size                    : '26' | '22' | '30'

    showRemoveButton?       : boolean
    showIcon?               : boolean
    showHint?               : boolean

    onClick?                : {(tagId:ID):void},
    onRemoved?              : {(taskId:ID | null | undefined, tagId:ID):void}
    onClickRemoveCallback?  : {(taskId:ID | null | undefined, tagId:ID):void}
}

// const debug = "TagView"
const debug = false

export default class TagView extends React.Component<Props> {

    static defaultProps = {
        showIcon            : false,
        showHint            : true,
        showRemoveButton    : false
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) {
            return
        }
        this.props.onClick?.(this.props.tag.id)
    }

    onRemoveClick = (e:any) => {
        if (isBulkSelection(e)) {
            return
        }

        e.stopPropagation()
        this.props.onClickRemoveCallback?.(this.props.taskId, this.props.tag.id)

        if (this.props.taskId) {
            const request = gd.api.Task.removeTag(this.props.taskId, this.props.tag.id)
            request.done((data: any)=>{
                this.props.onRemoved?.(this.props.taskId, this.props.tag.id)
            })
        } else {
            this.props.onRemoved?.(null, this.props.tag.id)
        }
    }

    render () {
        const classes = Classes('gd-tag-tile', 'size-'+this.props.size, this.props.className);

        const style = {
            backgroundColor: gd.skin.colors.paleBGColor({
                colorNumber: this.props.tag.color,
                corePalette: ColorPalette.CORE
            }),
            /*borderColor: gd.skin.colors.paleBorderColor({
                colorNumber: this.props.tag.color,
                corePalette: CorePalette.CORE
            })*/
        }

        const iconStyle = {
            color: gd.skin.colors.mainColor({
                colorNumber: this.props.tag.color,
                corePalette: ColorPalette.CORE
            })
        }

        const icon          = this.props.showIcon ? <div className="i5-tag-solid" style={iconStyle}/> : false;
        const hintRequired  = this.props.showIcon ? this.props.tag.name.length > 6 : this.props.tag.name.length > 9;
        const showHint      = this.props.showHint && hintRequired

        debug && console.log(debug, 'render', this.props.tag)

        return (
            <div className  = {classes}
                 style      = {style}
                 onClick    = {this.onClick}
            >
                {icon}
                <div className="txt-truncate">
                    {this.props.tag.name}
                </div>
                {this.props.showRemoveButton &&
                    <div className  = "delete-icon i5-delete"
                         onClick    = {this.onRemoveClick}
                    />}

                {showHint &&
                    <HintPopover hint={this.props.tag.name}/>}
            </div>
        );
    }
}